<div class="modal-header">
  <h4 class="modal-title">{{ "product_detail.activations.manage_title" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  @for (act of license.activations; track act) {
    <div class="manage-activations">
      <span>{{ act.comment }}</span>
      <span>{{ act.aquired | date }}</span>
      <button class="btn btn-danger btn-sm" [disabled]="loading" (click)="deactivate(act)">
        @if (!act.loading) {
          <span>{{ "general.remove" | translate }}</span>
        }
        @if (act.loading) {
          <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
        }
      </button>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
